import React from 'react';
import classes from './PermissionsSettings.module.scss';
import { Input } from 'antd';
import Assets from 'assets/icons';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hook';
import RowLoader from 'components/Sceletons/RowLoader';
import { setConfigurableFolder, setIsConfigureFolderOpen } from 'store/slices/dataPermissionsSlice';
import { IFolder } from 'interfaces';
import { fetchOnlyGroups } from 'store/reducers/usersGroupCreator';

const PermissionsSettings = () => {
  const [searchText, setSearchText] = React.useState('');
  
  const { userRootPermissions, foldersForPermissions, isLoadingPermissions } = useAppSelector((state) => state.permissions);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { groups } = useAppSelector((state) => state.dataUsers);

  const showLoader = !userRootPermissions || isLoadingPermissions;
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    !groups[0] && dispatch(fetchOnlyGroups(dataRoom?.id!));
  },[groups, dataRoom]);

  const allFolders = [{...userRootPermissions, name: t('Documents.modals.rootDir')}, ...foldersForPermissions];

  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const chooseFolder = (folder_id: string) => {
    const targetFolder = allFolders.find(folder => folder.id === folder_id);    
    dispatch(setConfigurableFolder(targetFolder as IFolder));
    dispatch(setIsConfigureFolderOpen(true));
  };
  
  const filteredAllFolders = React.useMemo(
    () => allFolders.filter(({ name }) => name?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())),
    [userRootPermissions, foldersForPermissions, searchText, i18n.language]
  );

  return (
    <div className={classes.rSidebarContent}>
      <div className={classes.search}>
        <Input
          suffix={<Assets.SearchIcon className={classes.searchIcon} />}
          allowClear
          value={searchText}
          onChange={onSearch}
          placeholder={t('rightSideBar.permissionsSection.search')}
          style={{ width: '100%' }}
        />
      </div>

      <div className={classes.permissions}>
        {showLoader
          ? [1, 2].map((el, i) => (<div key={`loader-${i}`} className={classes.buttonItem}>
            <RowLoader width={200} height={30} padding={'0px'} />
          </div>))
          : filteredAllFolders.map(folder => (
            <div key={folder.id} className={classes.buttonItem} onClick={() => chooseFolder(folder.id)}>
              <div className={classes.buttonText}>
                <div className={classes.folder}>{folder.name}</div>
              </div>
              <div className={classes.buttonPostfix}>
                <Assets.RightIcon />
              </div>
            </div>
          ))
        }
      </div>

    </div>
  );
}

export default PermissionsSettings;
